import React from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { BaasicSelectTemplate } from 'themes/components';

function BaasicSelect(props) {
	return <BaasicSelectTemplate {...props} />;
}

BaasicSelect.propTypes = {
	field: PropTypes.object,
	clearable: PropTypes.bool,
	onInputChange: PropTypes.func,
	options: PropTypes.oneOfType([PropTypes.array, MobxPropTypes.observableArray]),
	value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.array]),
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	placeholder: PropTypes.string,
	isLoading: PropTypes.bool,
	className: PropTypes.string,
	onDelete: PropTypes.func,
	isSuperAdmin: PropTypes.bool,
	hasDeletePermission: PropTypes.bool,
	canDelete: PropTypes.bool,
	isAddTemplate: PropTypes.bool,
	orderBy: PropTypes.string
};

export default BaasicSelect;
